import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { UIError } from "./errors";

var JoinEclub = /*#__PURE__*/function () {
  function JoinEclub(config, axios) {
    _classCallCheck(this, JoinEclub);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(JoinEclub, [{
    key: "setJoinEclub",
    value: function () {
      var _setJoinEclub = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var _this$axios$post$then;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$axios$post$then = this.axios.post(this.config.postfix.JOIN_ECLUB, payload).then(function (apiResp) {
                  return apiResp;
                })) === null || _this$axios$post$then === void 0 ? void 0 : _this$axios$post$then["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setJoinEclub(_x) {
        return _setJoinEclub.apply(this, arguments);
      }

      return setJoinEclub;
    }()
  }]);

  return JoinEclub;
}();

export { JoinEclub as default };